import React from 'react';
import {compose} from 'redux';
import {connect} from "react-redux";
import DateDisplay from "../../Boilerplate/DateDisplay";
import {Button, Card, Col, Divider, Row} from "antd";
import UserSmall from "../../Boilerplate/UserSmall";
import {CodeTag} from "../../Boilerplate/CodeTag";
import {canUpdate} from "../../Boilerplate/permissions";
import {RfiFiles} from "./RfiFiles";
import ChatWall from "../../Boilerplate/ChatWall";
import {compArr} from "../selectors";
import DateTimeDisplay from "../../Boilerplate/DateTimeDisplay";

const RfiDetail = ({ rfi, projectId, onEdit }) => {
  const rowWidth = 24;
  const keyWidth = 11;
  const valWidth = rowWidth - keyWidth;
  return (
    <Row gutter={24}>
      <Col span={17}>
        <Card
          className='bid-dashboard-info'
          title={`RFI #${rfi.resource.number} - ${rfi.resource.title}`}
          extra={
            <Button.Group>
              <Button onClick={onEdit} disabled={!canUpdate(rfi)}>Edit</Button>
            </Button.Group>
          }
        >
          <Row>
            <Col span={12}>
              <Row className='key-value'>
                <Col span={keyWidth}>Assigned To</Col>
                <Col span={valWidth}><UserSmall id={rfi.resource.owneruserid}/></Col>
              </Row>
              <Row className='key-value'>
                <Col span={keyWidth}>Due</Col>
                <Col span={valWidth}><DateDisplay date={rfi.resource.duedate}/></Col>
              </Row>
              <Row className='key-value'>
                <Col span={keyWidth}>Status</Col>
                <Col span={valWidth}><CodeTag table='projectrfistatus' code={rfi.resource.status}/></Col>
              </Row>
            </Col>
          </Row>
          <Row gutter={18} className='rfi-question-response'>
            <Col span={12}>
              <Card type='inner' title='Question'>
                <p className='formatted-text'>{rfi.resource.description}</p>
                Created by <UserSmall id={rfi.resource.createdbyuserid}/> at <DateTimeDisplay date={rfi.resource.datecreated}/>
              </Card>
            </Col>
            <Col span={12}>
              <Card type='inner' title='Response'>
                <p className='formatted-text'>{rfi.resource.reply}</p>
                {rfi.resource.reply && rfi.resource.replyuserid && rfi.resource.replydatetime &&
                <span>Reply by <UserSmall id={rfi.resource.replyuserid}/> at <DateTimeDisplay date={rfi.resource.replydatetime}/></span>}
              </Card>
            </Col>
          </Row>
          <div>
            <Divider>CSI Codes</Divider>
            <div>
              {rfi.resource.csicodes && rfi.resource.csicodes.map(code => (
                <CodeTag table='csi' key={code} code={code}/>
              ))}
            </div>
          </div>
        </Card>
        <RfiFiles/>
      </Col>
      <Col span={7}>
        <ChatWall projectId={projectId} rfiId={rfi.resource.id}/>
        {/*<Activity/>*/}
      </Col>
    </Row>
  );
};

export default compose(
  connect(
    (state, props) => {
      let projectId = props.match.params.id;
      let rfi = state.view.subview.data[props.match.params.rfiId];
      if (!rfi) return { loading: true };
      const loading = state.view.subview.cache.loading;
      const path = state.view.path;
      const itempath = ['projects', props.match.params.id, 'rfis', props.match.params.rfiId];
      if (!compArr(path, itempath) || loading || !rfi) return { loading: true };
      return { rfi, projectId };
    },
    (dispatch, props) => ({
      onEdit: () => props.history.push(`/projects/${props.match.params.id}/rfis/${props.match.params.rfiId}/edit`)
    })
  ),
)(RfiDetail);



// WEBPACK FOOTER //
// ./src/components/Projects/Rfis/RfiDetail.js